import { NgModule } from '@angular/core'
import { DisplayCountOwnersPipe } from './display-count-owners.pipe'

@NgModule({
    declarations: [DisplayCountOwnersPipe],
    exports: [DisplayCountOwnersPipe],
    providers: [DisplayCountOwnersPipe],
})
export class DisplayCountOwnersModule {
}